/**
 * Брейкпоинт шапки ERP — ОДНО место на все её части (меню, пункт меню,
 * правая группа, блок пользователя).
 *
 * Шапка подогнана под 1280 px: шесть групп меню, колокольчик, палитра, язык,
 * профиль и выход. Уже 1280 она не помещалась — всё `nowrap`, и страница
 * получала горизонтальную прокрутку (на 1100 px — около 100 px лишних).
 * Ниже брейкпоинта шапка «ужимается»: меньше зазоры и разрядка, у профиля
 * только имя (полный адрес — в подсказке кнопки профиля). На ≥ 1280 вид
 * прежний.
 *
 * Лежит в `components/constants`, а не рядом с `organisms/Menu`: им
 * пользуются атом (`UserInfo`) и молекула (`MenuItem`), а импорт снизу вверх
 * по Atomic Design запрещён.
 */
export const HEADER_COMPACT_MAX = 1279;

/** Готовое медиа-условие для styled-components. */
export const HEADER_COMPACT_MEDIA = `@media (max-width: ${HEADER_COMPACT_MAX}px)`;
